// extracted by mini-css-extract-plugin
export default {"columnHeader":"ColumnHeaderWithInfo_columnHeader__N31pB"};